var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 138,
    viewBox: "0 0 190 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 0H56.7608C26.8465 0 1.16545 23.4587 0.0366159 53.4179C-1.09222 85.073 24.0244 110.793 55.3497 110.793H90.9081C93.1658 110.793 94.8591 112.489 94.8591 114.75V134.817C94.8591 137.643 98.2456 139.056 100.221 137.078L125.338 111.923C126.184 111.075 127.031 110.793 128.16 110.793H133.24C163.154 110.793 188.835 87.3341 189.964 57.3748C191.093 26.0024 165.694 0 134.651 0Z",
    fill: "#47B972"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 30C110 27.2386 112.239 25 115 25C117.761 25 120 27.2386 120 30V64C120 66.7614 117.761 69 115 69C112.239 69 110 66.7614 110 64V30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 81C110 78.2386 112.239 76 115 76C117.761 76 120 78.2386 120 81C120 83.7614 117.761 86 115 86C112.239 86 110 83.7614 110 81Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalert);
export default __webpack_public_path__ + "static/media/calert.3d7cc5fb905f35285eecc8a429cf57c6.svg";
export { ForwardRef as ReactComponent };